// 参数配置
export default {
  measurements_lists: {
    'measurement4097': '空气温度',
    'measurement4098': '空气湿度',
    'measurement4099': '光照',
    'measurement4100': '二氧化碳',
    'measurement4101': '大气压',
    'measurement4102': '土壤温度',
    'measurement4103': '土壤湿度',
    'measurement4104': '风向',
    'measurement4105': '风速',
    'measurement4106': 'pH',
    'measurement4107': '光通量',
    'measurement4108': '电导',
    'measurement4109': '溶解氧',
    'measurement4110': '土壤体积含水量',
    'measurement4111': '土壤电导',
    'measurement4112': '土壤温度',
    'measurement4113': '每小时降雨量',
    'measurement4115': '距离',
    'measurement4116': '浸液',
    'measurement4117': '液位',
    'measurement4118': '氨气',
    'measurement4119': '硫化氢'
  }
}
